import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pt-[20px] pr-[0px] bg-[#ededed]" }
const _hoisted_2 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_3 = { class: "pt-[60px] pr-[20px] pb-[2%] pl-[10px]" }
const _hoisted_4 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_5 = { class: "pt-[30px] pr-[20px] pb-[40px] pl-[10px] text-center" }
const _hoisted_6 = {
  key: 0,
  id: "content"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import { useRoute } from 'vue-router'
    import useContactStore from '@/utils/useContactStore'
    import useOfferStore from '@/utils/useOfferStore'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import offerNavigation from '@/components/SubNavigations/TheOfferNavigation.vue'
    import OrganizationAndContactName from '@/components/Offers/OrganizationAndContactName.vue'
    import OffersSection from '@/components/Offers/OffersSection.vue'
    import { computed } from 'vue'
    import { Offer } from '@/model/types'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OffersSchoolview',
  setup(__props) {

    const route = useRoute()
    const { contacts, fetchContactsSearch } = useContactStore()
    const {
        offers,
        loading,
        selectOffer,
        confirmDeleteSingleOffer,
        downloadPdf,
        clearSelectedOfferStore,
        fetchOffers,
        hasLink,
    } = useOfferStore()
    const contactId = parseInt(route.params.id as string, 10)

    async function fetchDataOnMounted() {
        loading.value = true // Set loading to true before fetch
        await fetchContactsSearch({ limit: 1, offset: 0, filter: contactId.toString() })
        if (offers.value.length === 0) {
            await fetchOffers()
        }
        loading.value = false // Set loading to false after fetch
    }

    fetchDataOnMounted()

    // Computed properties
    const organizationName = computed(() => contacts.value[0]?.organisation?.name || '')
    const contactName = computed(
        () =>
            `${contacts.value[0]?.person?.firstName} ${contacts.value[0]?.person?.familyName}` || ''
    )
    const displayedOffers = computed(
        () => offers.value.find((o: Offer) => o.contactId == contactId)?.offers || []
    )

    // Breadcrumbs
    const breadcrumbs = computed(() => [
        { title: 'Offerten', disabled: false, href: '/offers' },
        { title: 'Schulansicht', disabled: true, href: '/offers/schoolview/' },
    ])

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(offerNavigation)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_breadcrumbs, { items: breadcrumbs.value }, null, 8, ["items"]),
      _createElementVNode("div", _hoisted_5, [
        (!_unref(loading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_unref(contacts).length >= 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(OrganizationAndContactName, {
                      contact: _unref(contacts)[0],
                      "contact-id": _unref(contactId),
                      "organization-name": organizationName.value,
                      "contact-name": contactName.value
                    }, null, 8, ["contact", "contact-id", "organization-name", "contact-name"]),
                    _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
                    _createVNode(OffersSection, {
                      offers: displayedOffers.value,
                      "contact-id": _unref(contactId),
                      selectOfferMethod: _unref(selectOffer),
                      deleteMethod: _unref(confirmDeleteSingleOffer),
                      pdfMethod: _unref(downloadPdf),
                      hasLink: _unref(hasLink)
                    }, null, 8, ["offers", "contact-id", "selectOfferMethod", "deleteMethod", "pdfMethod", "hasLink"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(FullButton, {
                link: '/offers/createoffer/' + _ctx.$route.params.id + '/0',
                onClick: _unref(clearSelectedOfferStore),
                title: _ctx.$t('offers.addOffer'),
                width: "100",
                colour: "red"
              }, null, 8, ["link", "onClick", "title"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('loading')), 1)
            ]))
      ])
    ])
  ]))
}
}

})